import { useSiteInfo } from "@/api/siteInfo";
import { Button } from "@/components/ui/button";

const WhatsAppButton = () => {
  const { data: siteInfo } = useSiteInfo();
  
  // Format phone number for WhatsApp (remove spaces, +, etc if needed)
  // Assuming the backend returns a full number like "+20 123 456 7890"
  // WhatsApp API usually expects clean number with country code, no + or spaces.
  const phoneNumber = siteInfo?.contact?.phone?.replace(/\D/g, "") || "";
  
  if (!phoneNumber) return null;

  const whatsappUrl = `https://wa.me/${phoneNumber}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 animate-fade-in hover:scale-110 transition-transform duration-300"
      aria-label="Contact us on WhatsApp"
    >
      <div className="bg-[#25D366] text-white p-3 rounded-full shadow-lg flex items-center justify-center w-14 h-14">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="white"
          className="w-8 h-8"
        >
          <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-8.68-2.031-9.67-.272-.099-.47-.149-.669-.149-.198 0-.42.001-.643.001-.223 0-.585.085-.891.42-.306.334-1.177 1.15-1.177 2.804 0 1.654 1.213 3.254 1.383 3.485.17.231 2.38 3.635 5.766 5.097 2.274.981 2.738.784 3.235.735.496-.05 1.758-.718 2.006-1.411.248-.693.248-1.288.173-1.413z" />
        </svg>
      </div>
    </a>
  );
};

export default WhatsAppButton;
